import {fetchWithAuth, fetchWithToken} from '@app/utils/httpClient';
import {consoleLog, getToken} from './helper';

function FormGet(model) {
    const formGet = [];
    Object.keys(model).forEach(function (property) {
        if (Array.isArray(model[property])) {
            model[property].forEach((element) => {
                const encodedKey = encodeURIComponent(property);
                const encodedValue = encodeURIComponent(element);
                formGet.push(`${encodedKey}=${encodedValue}`);
            });
        } else {
            const encodedKey = encodeURIComponent(property);
            const encodedValue = encodeURIComponent(model[property]);
            formGet.push(`${encodedKey}=${encodedValue}`);
        }
    });
    return formGet.join('&');
}

function Header(ContentType = '') {
    const token = getToken();
    const headers = new Headers();
    if (token) {
        headers.append('Authorization', `bearer ${token}`);
    }
    if (ContentType.length > 0) {
        headers.append('Content-Type', ContentType);
    }
    return headers;
}

// export async function Post(api, param = null, model, isLogin = false) {
//     let API = api;
//     if (param && param.toString().length > 0) {
//         API = `${API}/${param}`;
//     }

//     const headers = Header(
//         isLogin ? 'application/x-www-form-urlencoded' : 'application/json'
//     );

//     const body = isLogin ? FormGet(model) : JSON.stringify(model);

//     return fetch(API, {
//         method: 'POST',
//         headers: headers,
//         body: body
//     })
//         .then(async (res) => {
//             // if we got a 401, try to refresh once and then retry
//             if (res.status === 401) {
//                 await store.dispatch(refreshTokenFunc()).unwrap();
//                 // rebuild headers with new token
//                 const newHeaders = Header(
//                     isLogin
//                         ? 'application/x-www-form-urlencoded'
//                         : 'application/json'
//                 );
//                 return fetch(API, {method: 'POST', headers: newHeaders, body});
//             }
//             return res;
//         })
//         .then((res) => {
//             // if (convertToJson) {
//             //     if (res.status === 200 || res.status === 400 || res.status === 201) {
//             //         if (res.json() != null) return res.json();
//             //     }
//             // }
//             // return res;
//             // if (!res.ok) {
//             //     console.log(res.json()); // Check if the response status is not ok (200-299)
//             //     return res.json().then(err => Promise.reject(err)).catch((e) => Promise.reject({ message: e.message }));
//             // }
//             // return convertToJson ? res.json() : res;

//             if (isLogin) {
//                 return res;
//             } else {
//                 return res.json().then((body) => {
//                     // If the response was not OK, throw the body as the error
//                     if (!res.ok) {
//                         throw body;
//                     }
//                     // Otherwise, return the body for successful responses
//                     return res;
//                 });
//             }
//         });
//     // .catch((error) => {
//     //     consoleLog(error);
//     //     return null;
//     // });
// }

export async function Post(api, param = null, model, isLogin = false) {
    let url = api + (param ? `/${param}` : '');
    const headers = new Headers();
    let body,
        method = 'POST';

    if (isLogin) {
        headers.set('Content-Type', 'application/x-www-form-urlencoded');
        body = new URLSearchParams(model).toString();
        // login still goes straight to /connect/authorize via form POST
        return fetch(url, {method, headers, body});
    }

    headers.set('Content-Type', 'application/json');
    body = JSON.stringify(model);

    const res = await fetchWithAuth(url, {method, headers, body});
    if (!res.ok) throw await res.json();
    return res;
}

// export function Get(api, param = null, model = null) {
//     let API = api;
//     if (param) {
//         API = `${API}/${param}`;
//     }
//     if (model) {
//         API = `${API}?${FormGet(model)}`;
//     }

//     return fetch(API, {
//         method: 'GET',
//         headers: Header('application/json')
//     })
//         .then((res) => {
//             if (res.ok) return res.json();
//             return null;
//         })
//         .catch((error) => {
//             consoleLog(error);
//             return null;
//         });
// }

export async function Get(api, param = null, model = null) {
    let url = api;
    if (param) url += `/${param}`;
    if (model) url += `?${FormGet(model)}`;

    try {
        const res = await fetchWithAuth(url, {method: 'GET'});
        if (res == null || !res.ok) return null;
        return await res.json();
    } catch (err) {
        console.log(err);
        return null;
    }
}

// export async function GetWithToken(api, accessToken, param = null, model = null) {
//   let url = api;
//   if (param) url += `/${param}`;
//   if (model) url += `?${FormGet(model)}`;

//   try {
//     const res = await fetchWithToken(url, accessToken, { method: 'GET' });
//     if (res == null || !res.ok) return null;
//     return await res.json();
//   } catch (err) {
//     console.log(err);
//     return null;
//   }
// }

// export function DeleteSingle(api, param, model = null) {
//     let API = api;
//     if (param) {
//         API = `${API}/${param}`;
//     }
//     if (model) {
//         API = `${API}?${FormGet(model)}`;
//     }
//     return fetch(API, {
//         method: 'DELETE',
//         headers: Header('application/json'),
//         body: model ? JSON.stringify(model) : ''
//     })
//         .then((res) => res)
//         .catch((error) => {
//             consoleLog(error);
//             return error;
//         });
// }

export async function DeleteSingle(api, param = null, model = null) {
    let url = api;
    if (param) url += `/${param}`;
    if (model) url += `?${FormGet(model)}`;

    const headers = Header('application/json');

    // 1) send via fetchWithAuth
    const res = await fetchWithAuth(url, {
        method: 'DELETE',
        headers,
        body: model ? JSON.stringify(model) : ''
    });

    // 2) return raw response (as before)
    return res;
}

// export function Put(api, param = null, model = null) {
//     let API = api;
//     if (param) {
//         API = `${API}/${param}`;
//     }
//     return fetch(API, {
//         method: 'PUT',
//         headers: Header('application/json'),
//         body: model ? JSON.stringify(model) : ''
//     }).then((res) => {
//         return res.json().then((body) => {
//             if (!res.ok) {
//                 throw body;
//             }
//             return res;
//         });
//     });
// }

export async function Put(api, param = null, model = null) {
    let url = api;
    if (param) url += `/${param}`;

    const headers = Header('application/json');
    const body = (model !== null && model !== undefined) ? JSON.stringify(model) : '';

    // 1) send via fetchWithAuth
    const res = await fetchWithAuth(url, {
        method: 'PUT',
        headers,
        body
    });

    // 2) parse JSON and throw on error
    const data = await res.json();
    if (res == null || !res.ok) throw data;
    return res;
}

export async function Patch(api, param = null, model = null) {
    let url = api;
    if (param) url += `/${param}`;

    const headers = Header('application/json');
    const body = model ? JSON.stringify(model) : '';

    // 1) send via fetchWithAuth
    const res = await fetchWithAuth(url, {
        method: 'PATCH',
        headers,
        body
    });

    // 2) parse JSON and throw on error
    const data = await res.json();
    if (res == null || !res.ok) throw data;
    return res;
}

// export async function UploadFile(api, param, data) {
//     let API = api;
//     if (param) {
//         API = `${API}?${FormGet(param)}`;
//     }
//     const requestOptions = {
//         method: 'POST',
//         body: data,
//         headers: Header('')
//     };
//     return fetch(API, requestOptions)
//         .then(async (res) => res)
//         .catch((error) => {
//             return error;
//         });
// }

export async function UploadFile(api, param, data) {
    let url = api;
    if (param) {
        url = `${url}?${FormGet(param)}`;
    }

    try {
        // Pass your FormData body and empty-content-type Header to fetchWithAuth
        const res = await fetchWithAuth(url, {
            method: 'POST',
            headers: Header(''),
            body: data
        });
        return res;
    } catch (error) {
        // preserve your previous catch behavior
        return error;
    }
}

// export function GetLogin(api, param = null, model = null) {
//     let API = api;
//     if (param) {
//         API = `${API}/${param}`;
//     }
//     if (model) {
//         API = `${API}?${FormGet(model)}`;
//     }

//     return fetch(API, {
//         method: 'GET',
//         headers: {
//             'Content-Type': 'application/json; charset=utf-8'
//         }
//         // mode: 'no-cors'
//     })
//         .then((res) => {
//             if (res.ok) {
//                 return true;
//             }
//             return false;
//         })
//         .catch((error) => {
//             consoleLog(error);
//             return null;
//         });
// }

export async function GetLogin(api, param = null, model = null) {
    let url = api;
    if (param) url += `/${param}`;
    if (model) url += `?${FormGet(model)}`;

    try {
        const res = await fetchWithAuth(url, {
            method: 'GET',
            headers: {'Content-Type': 'application/json; charset=utf-8'}
        });
        return res.ok;
    } catch (error) {
        consoleLog(error);
        return null;
    }
}

// export async function DeleteLogin(api, param = null, model) {
//     let API = api;
//     if (param) {
//         API = `${API}/${param}`;
//     }
//     if (model) {
//         API = `${API}?${FormGet(model)}`;
//     }

//     return fetch(API, {
//         method: 'GET',
//         headers: Header('application/json')
//     })
//         .then((res) => {
//             if (res.ok) return null;
//             return null;
//         })
//         .catch((error) => {
//             consoleLog(error);
//             return null;
//         });
// }

export async function DeleteLogin(api, param = null, model) {
    let url = api;
    if (param) url += `/${param}`;
    if (model) url += `?${FormGet(model)}`;

    try {
        await fetchWithAuth(url, {
            method: 'GET',
            headers: Header('application/json')
        });
        return null;
    } catch (error) {
        consoleLog(error);
        return null;
    }
}
